import { render, staticRenderFns } from "./AddPeople.vue?vue&type=template&id=36ddab64&scoped=true&"
import script from "./AddPeople.vue?vue&type=script&lang=js&"
export * from "./AddPeople.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36ddab64",
  null
  
)

export default component.exports